import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    memo,
} from 'react'
import {
    Alert,
    Button,
    Col,
    Collapse,
    Row,
} from 'react-bootstrap'
import { colors } from '../../../styles/colors'
import { ArrowBigIcon } from '../../Icons/ArrowBigIcon'
import { StyledCollapseTrigger } from '../../Assets/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { MdLibraryAdd } from 'react-icons/md'
import { emptyGuid, isEmptyGuid } from '../../../utils/emptyGuid'
import ModalComponent from '../../Modals/ModalComponent'
import { getLanguageValue } from '../../../utils/getLanguageValue'
import { formatedDate } from '../../../utils/formatedDate'
import { FileTypeIcon } from '../../../utils/getFileTypeIcon'
import apiClient from '../../../utils/api/apiClient'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import DocumentInfoIcon from "../../../assets/icons/document_info.png"
import DocumentDeleteIcon from "../../../assets/icons/document_delete.png"
import DocumentUploadIcon from "../../../assets/icons/document_up.png"
import DocumentHistoryIcon from "../../../assets/icons/document_history.png"
import styled from 'styled-components';
import UploadDocumentModal from '../../DocumentsOGIS/UploadDocumentModal'
import HistoryDocumentModal from '../../DocumentsOGIS/HistoryDocumentModal'
import { makeCall } from '../../../utils/api/makeCall'
//import useMountEffect from '../../../utils/hooks/useMountEffect';
import { Spinner } from 'react-bootstrap'
import ArraySelect from '../../Select/ArraySelect'
const StyledImage = styled.div`
height:24px;
width:24px;
background-size: contain;
background-image: none;
background-image: url(${props => props.image ? props.image : ""});
`
const StyledDocumentWrapper = styled.a`
    min-height: 48px;
    color: ${colors.gray4};
    small {
        color: ${colors.gray3};
    }
    display: flex;
    align-items: center;
    margin: 5px 5px 5px 0 ;
    cursor: pointer;
`
const InstanceDocuments = memo(
    ({
        objectId,
        collapsible,
    }) => {
        const [/*errorStates*/, setErrorStates] = useState({})
        const [/*loadingStates*/, setLoadingStates] = useState({})

        const [loading, setLoading] = useState(false)
        const [opened, setOpened] = useState(!collapsible)
        const [documents, setDocuments] = useState([])
        const [document, setDocument] = useState(null)
        const [threads, setThreads] = useState([])
        const [thread, setThread] = useState(null)
        const ref = useRef()

        const mountedRef = useRef(true)
        const [openDeleteModal, setOpenDeleteModal] = useState(false)
        const [openUploadModal, setOpenUploadModal] = useState(false)
        const [openHistoryModal, setOpenHistoryModal] = useState(false)
        const [useFileUpload, setUseFileUpload] = useState(false)
        const handleClickCollapse = useCallback(() => {
            setOpened((prev) => !prev)
        }, [setOpened])
        const openUploadFile = (doc) => {
            setDocument(doc);
            setUseFileUpload(true)
            setOpenUploadModal(true)
        }
        const handleClose = (refresh) => {
            setOpenDeleteModal(false)
            setOpenUploadModal(false)
            setUseFileUpload(false)
            setOpenHistoryModal(false)
            if (refresh) {
                if (isEmptyGuid(thread?.id ?? emptyGuid,)) {
                    loadThreads();
                }
                else {
                    loadDocuments()
                }
            }
        }
        async function removeDocument(documentId) {
            await makeCall('removeDocument', async () => {
                await apiClient.deleteJson(APIEndpoints.documentAdmin(documentId).documents)
            }, setErrorStates, setLoadingStates)
        }
        const handleDeleteDocument = async () => {
            await removeDocument(document.id)
            handleClose(true)
        }
        const handleChangeThread = e => {
            let selectedThread = threads.find(obj => obj.id === e.id);
            setThread(selectedThread)
        }
        const { t } = useTranslation()
        const loadThreads = useCallback(() => {
            setLoading(true)
            apiClient.getJson(APIEndpoints.object(objectId).threads).then(resp => {
                if (!mountedRef.current) return null
                if(!resp.some(obj => obj.isDefault))
                {
                    resp.push({id : emptyGuid, displayName : 'LOGIX'})
                }
                let defThread = resp.find(obj => obj.isDefault);
                setThread(defThread)
                setThreads(resp)
                setLoading(false)
            })
                .catch(error => console.log(error))
        }, [objectId])
        const loadDocuments = useCallback(() => {
            if (isEmptyGuid(thread?.id ?? emptyGuid,)) {
                setDocuments([])
                return false;
            }
            setLoading(true)
            const params = {
                threadId: thread?.id ?? emptyGuid,
            }
            apiClient.getJson(APIEndpoints.object(objectId).documents, params).then(resp => {
                //if (!mountedRef.current) return null
                setDocuments(resp)
                setLoading(false)
            })
                .catch(error => console.log(error))
        }, [thread, objectId])

        /*useMountEffect(() => {
            loadThreads()
        })
        //Cleanup Function
        useEffect(() => {
            return () => { mountedRef.current = false }
        }, [])*/
        useEffect(() => {
            loadDocuments()
        }, [thread, loadDocuments])
        useEffect(() => {
            loadThreads()
        }, [objectId, loadThreads])

        const renderThreadSelector = () => {
            let showSelector = opened && threads && threads.length>1;
            return (showSelector ?
                <>
                    <ArraySelect
                        options={threads}
                        value={thread?.id ?? emptyGuid}
                        onChange={handleChangeThread}
                        name="thread"
                    />
                    <div className="mb-2" />
                </>
                : null)
        }
        if (loading && opened) {
            return (
                <div className='d-flex justify-content-center'>
                    <Spinner animation='border' variant='primary' />
                </div>
            );
        }
        return (
            <div ref={ref}>
                {collapsible ? (
                    <>
                        <StyledCollapseTrigger onClick={handleClickCollapse}>
                            <h3>
                                <ArrowBigIcon
                                    variant={opened ? 'down' : 'right'}
                                    color={colors.textColor}
                                    width={'20px'}
                                    height={'20px'}
                                />
                                {t('documents:documents')}
                            </h3>
                        </StyledCollapseTrigger>
                        {renderThreadSelector()}
                    </>
                ) : (
                    <>
                        <h3>{t('documents:documents')}</h3>
                        {renderThreadSelector()}
                    </>
                )}
                <Collapse in={opened}>
                    <div className='spacing-down'>
                        {documents.length === 0 && (

                            <Alert variant='info'>
                                {t('documents:noDocumentsExists')}
                            </Alert>
                        )}
                        {documents.map((item, index) => {
                            return (
                                <Row className='added-row' key={index}>
                                    <Col>
                                        <div className="d-flex justify-content-start">
                                            <StyledDocumentWrapper href={item.url} download={item.name} filename={item.name} target="_blank">
                                                <FileTypeIcon fileType={item.type} />
                                                <div >
                                                    <div className='fw-bold'>{item.name || ''}</div>
                                                    {getLanguageValue(item.description.values) && <div>
                                                        <small className='text-uppercase'>{getLanguageValue(item.description.values)}</small>
                                                    </div>}
                                                    <div>
                                                        <small className='text-uppercase'>{formatedDate(item.uploadtime ?? '')} - {item.uploadByDisplayName ?? ''}</small>
                                                    </div>
                                                </div>
                                            </StyledDocumentWrapper>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="d-flex justify-content-end">
                                            {item.hasVersions && <div data-toggle="tooltip" data-placement="right" title={t('documents:history')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentHistoryIcon} onClick={() => { setDocument(item); setOpenHistoryModal(true) }} />
                                            </div>}
                                            <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:upload')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentUploadIcon} onClick={() => openUploadFile(item)} />
                                            </div>
                                            <div data-toggle="tooltip" data-placement="right" title={t('delete')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentDeleteIcon} onClick={() => { setDocument(item); setOpenDeleteModal(true) }} />
                                            </div>
                                            <div data-toggle="tooltip" data-placement="right" title={t('documentAdmin:description')}>
                                                <StyledImage style={{ cursor: "pointer" }} image={DocumentInfoIcon} onClick={() => { setDocument(item); setOpenUploadModal(true) }} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            )
                        })}
                        <Button onClick={() => openUploadFile(null)} >
                            <MdLibraryAdd className='me-3' />
                            {t('documents:addDocuments')}
                        </Button>
                        {openDeleteModal && (<ModalComponent
                            ModalTitle={document?.name}
                            functionButton1={() => handleDeleteDocument()}
                            textButton1={t('delete')}
                            variantButton1="danger"
                            variantBody="alert-danger"
                            BodyPart1={t('documents:deleteDocumentBody')}
                            functionCancel={() => { setOpenDeleteModal(false) }}
                        />)}
                        {openUploadModal && (<UploadDocumentModal
                            objectId={objectId}
                            threadId={thread?.id ?? emptyGuid}
                            handleClose={handleClose}
                            documentData={document}
                            useFileUpload={useFileUpload}
                            useDefaultThread={true}
                            fileTypes={document ? [document?.type] : null}
                        />)}
                        {openHistoryModal && (<HistoryDocumentModal
                            documentData={document}
                            handleClose={handleClose}
                        />)}
                    </div>
                </Collapse>
            </div>
        )
    }
)

export default InstanceDocuments
